import type { ProjectType } from '@atlassian/jira-common-constants/src/index.tsx';
import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import type { Theme } from '@atlassian/jira-common-constants/src/theme-preference.tsx';
import type { ApplicationEditions } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { AccountId, CloudId, CloudName } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Environment } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const COMMOM_AREA = 'common' as const;
type AppName = 'jwm' | 'jsm' | 'jcs' | 'jsw' | 'jpd' | 'common';

type EditionKey =
	| 'core'
	| 'software'
	| 'serviceDesk'
	| 'customerService'
	| 'productDiscovery'
	| 'common';

type ProjectTypesForIPM = ProjectType | typeof COMMOM_AREA;

type ApplicationData = {
	apiKey: string;
	appName: AppName;
	editionKey: EditionKey;
};

// Now, define ApplicationKeyNameMapping using the string literal union type for keys
export type ApplicationKeyNameMapping = {
	[key in ProjectTypesForIPM]: ApplicationData;
};

export interface IPendoWidgetProps {
	atlassianAccountId: AccountId | null;
	cloudId: CloudId;
	cloudName: CloudName;
	appEditions: ApplicationEditions;
	apiKey: string;
	editionKey: EditionKey;
	appName: AppName;
	language: Locale;
	displayMode: Theme;
	environment: Environment;
}
